export default __webpack_public_path__ + "static/media/cover.5eef6ea2.jpg";